const styles = {
  cashbox: {
    height: 36
  }
}

export default styles
